import {Action, getModule, Module, Mutation} from 'vuex-module-decorators';
import store from '@/store';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {EntityModule} from './entityModule';
import {MeasurementType} from '@/views/system/measurements/enums';
import {PModuleType} from '@/enums/configs';
import {httpClient} from '@/api/baseApi';

/*
    Динамический модуль хранилища vuex для работы с измерениями
*/

const moduleName = 'measurementsModule';

function transformGet(elem: any): MeasurementData {
  return {
    id: elem.id,
    type: elem.type as MeasurementType,
    typeDescription: elem.type_description,
    moduleType: elem.module_type as PModuleType,
    moduleTypeDescription: elem.module_type_description,
    alias: elem.alias,
    name: elem.name,
    shortName: elem.short_name,
    phys: elem.phys,
    unit: elem.unit,
    xAxisDescription: elem.x_axis_desc,
    yAxisDescription: elem.y_axis_desc,
    eventType: elem.event_type,
    spectrumType: elem.spectrum_type,
    topWarningBoundary: elem.top_warning_boundary,
    topDangerBoundary: elem.top_danger_boundary,
    topErrorBoundary: elem.top_error_boundary,
    bottomWarningBoundary: elem.bottom_warning_boundary,
    bottomDangerBoundary: elem.bottom_danger_boundary,
    bottomErrorBoundary: elem.bottom_error_boundary,
  };
}

function transformCreateEdit(elem: any): MeasurementData {
  return {
    type: elem.type as MeasurementType,
    moduleType: elem.module_type as PModuleType,
    alias: elem.alias,
    name: elem.name,
    shortName: elem.short_name,
    phys: elem.phys,
    unit: elem.unit,
    xAxisDescription: elem.x_axis_desc,
    yAxisDescription: elem.y_axis_desc,
    eventType: elem.event_type,
    spectrumType: elem.spectrum_type,
    topWarningBoundary: elem.top_warning_boundary,
    topDangerBoundary: elem.top_danger_boundary,
    topErrorBoundary: elem.top_error_boundary,
    bottomWarningBoundary: elem.bottom_warning_boundary,
    bottomDangerBoundary: elem.bottom_danger_boundary,
    bottomErrorBoundary: elem.bottom_error_boundary,
  };
}

function transformSave(model: MeasurementData): any {
  return {
    type: model.type,
    module_type: model.moduleType,
    alias: model.alias,
    name: model.name,
    short_name: model.shortName,
    phys: model.phys,
    unit: model.unit,
    x_axis_desc: model.xAxisDescription,
    y_axis_desc: model.yAxisDescription,
    event_type: model.eventType,
    spectrum_type: model.spectrumType,
    top_warning_boundary: model.topWarningBoundary,
    top_danger_boundary: model.topDangerBoundary,
    top_error_boundary: model.topErrorBoundary,
    bottom_warning_boundary: model.bottomWarningBoundary,
    bottom_danger_boundary: model.bottomDangerBoundary,
    bottom_error_boundary: model.bottomErrorBoundary,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class MeasurementsModule extends EntityModule {
  protected routeName = 'module_type_measurements';
  public entities: MeasurementData[] = [];
  protected filterModule: PModuleType | null = null;

  get all(): MeasurementData[] {
    const all: MeasurementData[] = super.all as MeasurementData[];
    if (this.filterModule == null) return all;
    return all.filter(m => m.moduleType == this.filterModule);
  }

  @Mutation
  filterList(filter: PModuleType | null) {
    this.filterModule = filter;
  }

  @Action
  filterListAction(filter: PModuleType | null) {
    this.context.commit('filterList', filter);
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return await super.fetchAll(transformGet);
  }

  //Получение модели для создания объекта
  @Action
  public async create(): Promise<{data: MeasurementData}> {
    return super.create(transformCreateEdit) as Promise<{data: MeasurementData}>;
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any): Promise<{data: MeasurementData}> {
    return super.edit(id, transformCreateEdit) as Promise<{data: MeasurementData}>;
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: MeasurementData) {
    return super.save(model, transformSave);
  }

  //Импорт записей
  @Action
  public async import(formData: FormData) {
    try {
      const {data} = await httpClient.post(`/${this.routeName}/import/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }

  //Экспорт записей
  @Action
  public async export() {
    try {
      const {data} = await httpClient.get(`/${this.routeName}/export/`);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(MeasurementsModule);
